import { ofType } from 'redux-observable';
import { EMPTY, merge, of, Subject } from 'rxjs';
import { mergeMap, take, takeUntil } from 'rxjs/operators';

import { noop } from 'ui-components/default-props/noop';

import { InsuranceTermsService } from './insurance-terms-service';
import { USER_SETTING_SAVE_REQUEST_SUCCESS } from '../store/user/user.actions';

export const launchShipsuranceTermsModalWaitToProceed = (action$, nextAction, insuranceProviderId, onDeclineAction) => {
  const cancelSubject = new Subject();
  const onDeclineTerms = () => cancelSubject.next(true);
  InsuranceTermsService.launchInsuranceTermsModal(noop, onDeclineTerms, insuranceProviderId);
  return merge(
    action$.pipe(
      takeUntil(cancelSubject),
      ofType(USER_SETTING_SAVE_REQUEST_SUCCESS),
      take(1),
      mergeMap(() => {
        return of(nextAction);
      }),
    ),
    // A declined terms modal never reaches the purchase — surface an explicit abort so dependent
    // UI (e.g. Pick & Pack Station's isPurchasing lock) can reset instead of waiting forever.
    cancelSubject.pipe(
      take(1),
      mergeMap(() => (onDeclineAction ? of(onDeclineAction) : EMPTY)),
    ),
  );
};
